export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    // VibeVox: всегда наш фавикон (раньше подставлялся бейдж-фавикон Chatwoot).
    const newFileName = `/vibevox-favicon.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        // VibeVox: восстанавливаем наш фавикон (раньше возвращался фавикон Chatwoot).
        const oldFileName = `/vibevox-favicon.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
